export const SPINNER_VARIANTS = {
    fixed: "fixed inset-0 bg-white bg-opacity-75 z-50",
    centered: "flex flex-col items-center justify-center",
}

export const SPINNER_CONFIG = {
    colors: {
        primary: "text-blue-500",
        primaryDark: "text-blue-600",
        primaryDarker: "text-blue-700",
        text: "text-gray-700",
        textSecondary: "text-gray-500",
        textDark: "text-gray-800",
        bgPing: "bg-blue-100",
    },
    sizes: {
        icon: {
            simple: "h-16 w-16",
            compact: "size-4",
            medium: "h-12 w-12",
        },
    },
    animations: {
        spin: "animate-spin",
        ping: "animate-ping",
    },
    spacing: {
        iconMargin: "mb-4",
        titleMargin: "mt-6",
        subtitleMargin: "mt-2",
    },
    defaults: {
        minHeight: "min-h-[300px]",
        padding: "p-10",
        border: "border rounded-2xl",
    },
};

export const SPINNER_BACKGROUNDS = {
    gradient: "bg-gradient-to-br from-white to-gray-100 shadow-lg",
    solid: "bg-white",
};

export const SPINNER_TEXT_STYLES = {
    title: "text-lg font-semibold",
    titleLarge: "text-xl font-semibold",
    subtitle: "text-sm",
    subtitleMedium: "text-base font-medium",
};

export const DYNAMIC_IR_SUBTITLES = [
    "Retrieving the latest case information...",
    "Consolidating analyses, observations & recommendations...",
    "Structuring information into relevant sections...",
    "Almost done, applying final touches..."
];

export const SUBTITLE_TIMINGS = {
    first: 1000,
    second: 2500,
    third: 4000,
};